import { GraduationCap } from "@phosphor-icons/react";
import { Trans, useTranslation } from "react-i18next";

export function WhySection() {
  const { t } = useTranslation(["newLanding"]);
  return (
    <section className="flex flex-col items-center w-full px-4 py-10 sm:py-14 md:py-16 bg-light-green">
      <GraduationCap className="mb-12" weight="bold" size={40} />
      <h2 className="text-2xl font-semibold tracking-tight text-center sm:text-3xl md:text-4xl">
        <Trans i18nKey="why.title" ns="newLanding">
          <strong>banana</strong> banana
        </Trans>
      </h2>
      <p className="mb-12">{t("why.subtitle")}</p>
      <div className="grid w-full max-w-screen-md grid-cols-1 gap-5 sm:grid-cols-6 auto-rows-auto">
        <figure className="flex flex-col col-span-1 overflow-hidden border rounded-lg sm:flex-row sm:col-span-4 bg-background">
          <figcaption className="flex flex-col justify-center flex-1 gap-2 p-5 sm:p-6">
            <h3 className="text-2xl font-bold tracking-tight text-dark-green">
              {t("why.1.title")}
            </h3>
            <p className="text-xs leading-relaxed text-muted-foreground">
              {t("why.1.description")}
            </p>
          </figcaption>
          <div className="relative flex-shrink-0 w-full h-40 sm:h-auto sm:w-40 md:w-56">
            <img
              src="/assets/login-c.png"
              alt=""
              className="object-cover w-full h-full"
              loading="lazy"
            />
            <div
              className="absolute inset-0 pointer-events-none bg-gradient-to-r from-background via-background/80 to-transparent"
              aria-hidden="true"
            />
          </div>
        </figure>
        <div className="flex flex-col col-span-1 gap-2 p-4 rounded-lg bg-dark-green sm:col-span-2 sm:mb-4">
          <h3 className="mb-4 text-2xl font-bold leading-none tracking-tight text-primary-foreground">
            {t("why.2.title")}
          </h3>
          <p className="text-xs leading-relaxed text-primary-foreground">
            {t("why.2.description")}
          </p>
        </div>
        <div className="col-span-1 p-4 rounded-lg bg-dark-green sm:col-span-2">
          <h3 className="mb-4 text-2xl font-bold leading-none tracking-tight text-primary-foreground">
            {t("why.3.title")}
          </h3>
          <p className="text-xs leading-relaxed text-primary-foreground">
            {t("why.3.description")}
          </p>
        </div>
        <div className="col-span-1 p-4 rounded-lg bg-dark-green sm:col-span-2">
          <h3 className="mb-4 text-2xl font-bold leading-none tracking-tight text-primary-foreground">
            {t("why.4.title")}
          </h3>
          <p className="text-xs leading-relaxed text-primary-foreground">
            {t("why.4.description")}
          </p>
        </div>
        <div className="col-span-1 p-4 border rounded-lg bg-background sm:col-span-2 sm:-mt-4">
          <h3 className="mb-4 text-2xl font-bold leading-none tracking-tight text-dark-green">
            {t("why.5.title")}
          </h3>
          <p className="text-xs leading-relaxed text-muted-foreground">
            {t("why.5.description")}
          </p>
        </div>
      </div>
    </section>
  );
}
